import React from 'react'

import { useAppDispatch, useAppSelector } from '@/core/store'
// import { setGotTutorial } from '@/core/store/catalog.store'
import { closeModal } from '@/core/store/ui.store'
import { setModal } from '@/core/store/ui.store'

export const TutorialPrompt = () => {
  const { modal } = useAppSelector((store) => store.uiState)
  const dispatch = useAppDispatch()
  return (
    <div className={'tutorial-prompt' + (modal === 'tutorial-prompt' ? ' active' : '')}>
      <div className="tutorial-prompt-container">
        <div className="tutorial-prompt-text">
          <span className="tpt-question">Do you need</span>
          <h2>A TUTORIAL?</h2>
          <span className="tpt-description">
            Briefly about the most important functions of the application
          </span>
        </div>
        <button
          className="tp-start-button"
          onClick={() => {
            dispatch(closeModal())
            dispatch(setModal({ name: 'tutorial-slides' }))
            // dispatch(setGotTutorial(true))
          }}
        >
          Start &gt;
        </button>
        <button
          className="tp-close-button"
          onClick={() => {
            dispatch(closeModal())
            // dispatch(setGotTutorial(true))
          }}
        >
          Not now &gt;
        </button>
      </div>
    </div>
  )
}
